import { useEffect, useState } from "react";
import Button from "../../components/FormComponents/Button";
import axiosInstance from "../../services/axiosService";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import Input from "../../components/FormComponents/Input";
import { useModalContext } from "../../context/ModalContext";
import Loader from "../../Layouts/Loader/Loader";
import ErrorMessage from "../../components/FormComponents/ErrorMessage";
import "./ProxyRoutes.css";

const ProxyContent = () => {
  const [loading, setLoading] = useState(false);
  const [routes, setRoutes] = useState([]);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({});
  const { getUserConfirmationForDelete } = useModalContext();

  const fetchRoutes = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/proxy_routes");
      setRoutes(res.data);
    } catch (err) {
      setError(err);
    }
    setLoading(false);
  };

  const handleSubmit = async () => {
    try {
      if (editingId) {
        await axiosInstance.put(`/proxy_routes/${editingId}`, form);
      } else {
        await axiosInstance.post("/proxy_routes", form);
      }
      setForm({});
      setEditingId(null);
      setIsModalOpen(false);
      fetchRoutes();
    } catch (err) {
      setError(err);
    }
  };

  const handleEdit = (route) => {
    setForm(route);
    setEditingId(route.id);
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    const userConfirmed = await getUserConfirmationForDelete("Route");
    if (userConfirmed) {
      try {
        await axiosInstance.delete(`/proxy_routes/${id}`);
        fetchRoutes();
      } catch (err) {
        setError(err);
      }
    }
  };

  const openCreateModal = () => {
    setForm({});
    setEditingId(null);
    setIsModalOpen(true);
  };

  useEffect(() => {
    fetchRoutes();
  }, []);

  if (loading)
    return (
      <div className="w_100 h_100 d_flex justify_center align_center">
        <Loader />
      </div>
    );

  if (error)
    return (
      <div className="w_100 d_flex justify_center align_center">
        <ErrorMessage>Error loading routes</ErrorMessage>
      </div>
    );

  return (
    <div className="proxy_form_container h_100">
      <div className="proxy_header">
        <h1>Proxy Routes</h1>
        <Button onClick={openCreateModal} variant="primary" size="medium">
          Add Route
        </Button>
      </div>

      <table className="proxy_table">
        <thead>
          <tr>
            <th>Source</th>
            <th>Destination</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {routes.map((route) => (
            <tr key={route.id}>
              <td>
                {route.source_domain}
                {route.source_path}
              </td>
              <td>
                {route.destination_domain}
                {route.destination_path}
              </td>
              <td>{route.description}</td>
              <td className="d_flex gap_2">
                <Button onClick={() => handleEdit(route)} variant="primary" size="small">
                  Edit
                </Button>
                <Button onClick={() => handleDelete(route.id)} variant="delete" size="small">
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <BuilderModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        modalName={editingId ? "Edit Proxy Route" : "Create Proxy Route"}
      >
        <div className="proxy_form_modal">
          <Input
            label="Source Domain"
            placeholder="Enter source domain"
            value={form.source_domain || ""}
            onChange={(e) => setForm({ ...form, source_domain: e.target.value })}
          />
          <Input
            label="Source Path"
            placeholder="Enter source path"
            value={form.source_path || ""}
            onChange={(e) => setForm({ ...form, source_path: e.target.value })}
          />
          <Input
            label="Destination Domain"
            placeholder="Enter destination domain"
            value={form.destination_domain || ""}
            onChange={(e) => setForm({ ...form, destination_domain: e.target.value })}
          />
          <Input
            label="Destination Path"
            placeholder="Enter destination path"
            value={form.destination_path || ""}
            onChange={(e) => setForm({ ...form, destination_path: e.target.value })}
          />
          <Input
            label="Description"
            placeholder="Enter description"
            value={form.description || ""}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
          <div className="modal_buttons">
            <Button onClick={handleSubmit} variant="primary" size="medium">
              {editingId ? "Update Route" : "Create Route"}
            </Button>
          </div>
        </div>
      </BuilderModal>
    </div>
  );
};

export default ProxyContent;
